import DOMPurify from 'isomorphic-dompurify';
import he from 'he';
import parse, { Element, type HTMLReactParserOptions } from 'html-react-parser';

const INLINE_FONT_FAMILY = /font-family\s*:[^;]*;?/gi;

// Greenhouse's editor wraps job copy in inline `font-family` spans (Helvetica), which beat the site font.
// Other inline styles, like link colors, are kept.
const parserOptions: HTMLReactParserOptions = {
  replace(domNode) {
    if (!(domNode instanceof Element) || !domNode.attribs.style) return;

    const style = domNode.attribs.style.replace(INLINE_FONT_FAMILY, '').trim();
    if (style) {
      domNode.attribs.style = style;
    } else {
      delete domNode.attribs.style;
    }
  },
};

// Greenhouse returns the job HTML entity-encoded: decode, then sanitize.
export const parseJobContent = (content: string) =>
  parse(DOMPurify.sanitize(he.decode(content), { USE_PROFILES: { html: true } }), parserOptions);
